/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberProfileDimensionModel } from '../../models/member-profile-dimension-model';
import { SetMemberProfileDimensionsModel } from '../../models/set-member-profile-dimensions-model';

export interface ConsumerDimensionPost$Params {
      body?: SetMemberProfileDimensionsModel
}

export function consumerDimensionPost(http: HttpClient, rootUrl: string, params?: ConsumerDimensionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MemberProfileDimensionModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerDimensionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MemberProfileDimensionModel>>;
    })
  );
}

consumerDimensionPost.PATH = '/Consumer/Dimension';
